module.exports = __webpack_public_path__ + "img/003-apple.6be40eb4.svg";